import { gql } from '@lichtblick/apollo';

export const GET_WORKFLOW_DEFINITIONS = gql`
  query getWorkflowDefinitions_V1 {
    getWorkflowDefinitions_V1(input: { page: { number: 0, size: 100 } }) {
      totalItems
      error
      data {
        id
        name
      }
    }
  }
`;

export const GET_WORKFLOW_DEFINITIONS_COMPOSITE = gql`
  query getWorkflowDefinitionsComposite_V1 {
    getWorkflowDefinitionsComposite_V1 {
      error
      data {
        appointmentTypes {
          id
          name
        }
        blockerReasons {
          id
          title
        }
        workflowDefinitions {
          id
          name
        }
      }
    }
  }
`;
